module.exports = __webpack_public_path__ + "static/logo-placeholder-88ff1ba98f5d3538397c5426e1150c96.svg";